import { Button } from "antd";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import EditButtonIcon from "../../../assets/icons/EditButtonIcon";
import {
  useGetEmployeeBreakdownSalaryDetailsQuery,
  useLazyDownloadSalaryCertificateQuery,
} from "../../../features/employeeSalarySetting/employeeSalarySettingApi";
import { useGetPayrollSettingQuery } from "../../../features/payrollSetting/payrollSettingApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import InfoItem from "../../common/InfoItem";
import ConfirmModal from "../../ui/ConfirmModal";
import Loader from "../../ui/Loader";
import EditButtonEmployee from "./EditButtonEmployee";

type SalaryInfoProps = {
  showEditButton: boolean;
};

export default function SalaryInfo({ showEditButton }: SalaryInfoProps) {
  const { viewId } = useParams();
  const navigate = useNavigate();
  const { open, handleOpen, handleClose } = useModal<
    undefined,
    "EDITABLE_SETTING"
  >();
  const { isLoading, isError, error, data } =
    useGetEmployeeBreakdownSalaryDetailsQuery(viewId || "", {
      skip: !viewId,
    });

  const [
    downloadSalaryCertificate,
    { isLoading: isDownloading, data: pdfUrl },
  ] = useLazyDownloadSalaryCertificateQuery();
  const {
    data: payrollSettingData,
    isError: isPayrollSettingError,
    error: payrollSettingError,
  } = useGetPayrollSettingQuery();
  useError(isError, error, "Get salary setting fail");
  useError(
    isPayrollSettingError,
    payrollSettingError,
    "Gross salary configured data fail "
  );

  const isNotEditable =
    !payrollSettingData?.data?.payroll_setting?.pay_components?.pay_schedule
      ?.is_enable;

  const salaryData = data?.data?.salary_info;

  const findCompanyData = (key: string) => {
    return salaryData?.breakdown_percentage?.find((item) => item?.name === key);
  };

  const handleDownloadSalaryCertificate = () => {
    downloadSalaryCertificate({
      params: { business_member_id: Number(viewId) },
    });
  };

  useEffect(() => {
    if (pdfUrl) {
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "salary_certificate.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [pdfUrl]);

  // useEffect(() => {
  //   if (data) {
  //     if (data?.statusCode >= 400 && data?.statusCode < 500) {
  //       handleOpen({ type: "VIEW" });
  //     }
  //   }
  // }, [data, handleOpen]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {open?.type === "EDITABLE_SETTING" && (
        <ConfirmModal
          open={open?.open}
          handleClose={handleClose}
          handleOk={() => navigate("/admin/settings/payroll/pay-schedule")}
          confirmTitle="Payroll system is not enabled"
          questionText="Please enable the payroll system to edit the salary."
          okText="Go to setting"
        />
      )}
      <ul>
        {salaryData?.global_gross_salary_component
          ?.filter((item) => item?.is_active)
          ?.map((item) => (
            <InfoItem title={item?.title} key={item?.id}>
              {findCompanyData(item?.name)?.amount}
            </InfoItem>
          ))}
        <InfoItem title="Gross Salary">
          {Number(salaryData?.gross_salary) || "N/A"}
        </InfoItem>
        <InfoItem title="Salary Certificate">
          {salaryData?.breakdown_percentage.length === 0 ? (
            <>
              <div>N/A</div>
            </>
          ) : (
            <>
              <Button
                className="download-button !p-0 !h-fit !border-none !shadow-none"
                size="small"
                icon={<DownloadIcon />}
                loading={isDownloading}
                onClick={handleDownloadSalaryCertificate}
              >
                Download
              </Button>
            </>
          )}
        </InfoItem>
        {isNotEditable && viewId ? (
          <li className="mt-6 mb-1.5">
            <Button
              className="outline-button-primary !min-w-[151px] h-10"
              icon={<EditButtonIcon />}
              onClick={() => handleOpen({ type: "EDITABLE_SETTING" })}
            >
              Edit
            </Button>
          </li>
        ) : (
          <>{!showEditButton && <EditButtonEmployee type="Salary" />}</>
        )}
        {/* {!showEditButton && <EditButtonEmployee type="Salary" />} */}
      </ul>

      {/* <PrintableContent ref={currentRef}>
        <SalaryCertificatePDF />
      </PrintableContent> */}
    </>
  );
}
